<template>
  <div class="calico-top-factor">
    <i
      v-if="Number(String(score).replace('%','')).toFixed(2) > 0"
      class="bi bi-plus-circle"
    />
    <i
      v-else
      class="bi bi-dash-circle"
    />
    <span class="body--medium">{{ title }}</span>
  </div>
</template>

<script>
export default {
    name: "CalicoTopFactors",
    props: {
        score: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ""
        }
    },
};
</script>

<style lang="scss">
.calico-top-factor {
    @include inline-space($space-medium);
    color: $color-text-primary-alt;
    .bi {
        font-size: $icon-medium;
    }
    .bi-plus-circle {
        color: $color-green;
    }
    .bi-dash-circle {
        color: $color-red;
    }
}
</style>